import './App.css';
import {Grid} from "@mui/system";
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/800.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import Pagina from "./Pagina/Pagina";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect, useState} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {collection, orderBy, query} from "firebase/firestore";
import {fire} from "./fire";
import {Button} from "@mui/material";
import {obtenerCol} from "./Servicios/BD/obtenerCol";
import {actualizarDoc} from "./Servicios/BD/actualizarDoc";

export const contexApp = createContext()


function App() {
    const [cargando, setCargando] = useState(false)
    const {data: categorias, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({
        clave: 'categorias',
    })

    const valoresProvider = {
        categorias,
    }

    const {Provider} = contexApp;


    const colocarPrioridades = async () => {

        setCargando(true)
        let dox = await obtenerCol('productos')
        let productos = dox.data

        for (let producto of productos) {
            let catego = categorias.filter((cat) => cat.nombre === producto.categoria)[0]
            await actualizarDoc('productos', producto.id, {prioridad: catego.prioridad})
        }

        setCargando(false)

    }


    useEffect(() => {

        //se verifica si esta o no actualizado

        obtenerFechaAct('categorias').then((dox) => {
            let w = []
            let q = query(collection(fire, 'categorias'), orderBy('prioridad', 'asc'))
            actCategorias({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('espacios').then((dox) => {
            let w = []
            let q = query(collection(fire, 'categorias'), orderBy('prioridad', 'asc'))
            actCategorias({fecha: dox, wheres: w, query: q}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <h1 style={{display: 'none'}}>Quesuditas la mejor cafeteria en Ipiales</h1>
            <h2 style={{display: 'none'}}>Arepas Ipiales</h2>
            <h2 style={{display: 'none'}}>Empanadas Ipiales</h2>
            <h2 style={{display: 'none'}}>Buñuelos Ipiales</h2>
            <h2 style={{display: 'none'}}>Cafeteria en Ipiales</h2>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

            {/*<Button
                loading={cargando}
                onClick={() => colocarPrioridades()}
            >
                Colocar prioridad
            </Button>*/}

        </Grid>
    );
}

export default App;
